import { FC } from "react";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";

import Button from "@/components/Button";
import Text from "@/components/Text";
import { OptimisationProjectNetworkEnum } from "@/utils/enums";

const Alert = styled.div`
  margin-top: 20px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  border-left: 5px solid ${({ theme }) => theme.colors.error};
  padding: 12px 16px 12px 12px;
  display: flex;
  align-items: center;
`;

const Icon = styled.svg`
  color: ${({ theme }) => theme.colors.error};
  margin-right: 8px;
`;

const StyledButton = styled(Button)`
  margin-left: auto;
`;

interface Props {
  network: OptimisationProjectNetworkEnum;
}

const InvalidSettingsAlert: FC<Props> = ({ network }) => {
  const { teamId } = useParams();

  const networkLabel =
    network === OptimisationProjectNetworkEnum.YOUTUBE ? "youtube" : "facebook";

  return (
    <Alert>
      <Icon
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="18" height="18" rx="9" fill="currentColor" />
        <path
          d="M8 11.5882V13H10V11.5882H8ZM8 5V10.6471H10V5H8Z"
          fill="white"
        />
      </Icon>
      <Text $type="smallBold">Actions required in Optimisation settings.</Text>
      <StyledButton
        small
        color="secondary"
        forwardedAs={Link}
        to={`/teams/${teamId}/testing-settings?tab=${networkLabel}`}
      >
        Go to Settings
      </StyledButton>
    </Alert>
  );
};

export default InvalidSettingsAlert;
